import identity from 'lodash/identity';
import { createSelector } from 'reselect';
import { LOCATION_KEY } from './constants';

export const getLocation = createSelector(
    state => state[LOCATION_KEY],
    identity,
);
